module.exports = __webpack_public_path__ + "app-static/img/face-3.a29a8442.png";